import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import styles from './AddCouponDialog.module.css'
import { Button } from '@/components/Button'
import { TextInput } from '@/components/inputs/TextInput'

export interface AddCouponDialogProps {
  showing: boolean
  onClose: () => unknown
  isPending: boolean
  onApply: () => unknown
  couponCode: string
  onCouponCodeChange: (code: string) => unknown
}

export function AddCouponDialog({
  showing,
  onClose,
  isPending,
  onApply,
  couponCode,
  onCouponCodeChange,
}: AddCouponDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            <div className={styles.header}>Add coupon</div>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            <div className={styles.header}>
              Type the coupon code to apply to this job.
            </div>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>

        <div className={styles.searchContainer}>
          <TextInput
            placeholder="Enter the coupon code"
            value={couponCode}
            onChange={(event) => onCouponCodeChange(event.target.value)}
            onPaste={(event) => event.preventDefault()}
            onDrop={(event) => event.preventDefault()}
            autoFocus
          />
        </div>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            isDisabled={isPending}
            onPress={onClose}
          />
          <Button
            label="Apply"
            variant="primary"
            isPending={isPending}
            onPress={onApply}
            isDisabled={!couponCode || isPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
